import { differenceInCalendarDays, endOfDay, startOfDay } from 'date-fns';

import { MAX_DATE_RANGE_DAYS } from '../config/dateRangeConfig';
import type { TimeSeriesChartDateRange } from '../types/TimeSeriesChartDateRange.types';

/** The picker and URL share this rule: at most 31 calendar days, through today. */
export function isValidDateRange({ from, to }: TimeSeriesChartDateRange, now = new Date()): boolean {
  const fromTime = from.getTime();
  const toTime = to.getTime();

  return (
    Number.isFinite(fromTime) &&
    Number.isFinite(toTime) &&
    fromTime < toTime &&
    toTime <= endOfDay(now).getTime() &&
    differenceInCalendarDays(to, from) < MAX_DATE_RANGE_DAYS
  );
}

/** A newly selected target opens on the current day. */
export function getDefaultDateRange(): TimeSeriesChartDateRange {
  const today = new Date();

  return { from: startOfDay(today), to: endOfDay(today) };
}
